import InvitationLinksTable from './InvitationLinksTable';
export default InvitationLinksTable;
